import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const dynamicPermissions = _.result(config.get('permissions'), 'dynamic', {});
const { IsRenameHotelToLodgingEnabled } = dynamicPermissions;

export const reportType = {
  AccountPerformanceReport: _TL_('Account'),
  'AccountPerformanceReport-SixWeeks': _TL_('Account - 6 weeks'),
  'AccountPerformanceReport-TwoMonths': _TL_('Account - 2 months (MoM)'),
  'AccountPerformanceReport-TwoYears': _TL_('Account - 2 years (YoY)'),
  'AccountPerformanceReport-ShareOfVoice': _TL_('Account - Share of voice'),
  AdDynamicTextPerformanceReport: _TL_('Ad dynamic text'),
  AdExtensionByAdReport: _TL_('Ad extension by ad'),
  AdExtensionByKeywordReport: _TL_('Ad extension by keyword'),
  AdExtensionDetailReport: _TL_('Ad extension details'),
  AdGroupPerformanceReport: _TL_('Ad group'),
  AdPerformanceReport: _TL_('Ad'),
  AgeGenderAudienceReport: _TL_('Age and gender'),
  AudiencePerformanceReport: _TL_('Audiences'),
  BudgetSummaryReport: _TL_('Budget'),
  BillingStatementReport: _TL_('Billing statement'),
  CallDetailReport: _TL_('Call forwarding detail'),
  CampaignPerformanceReport: _TL_('Campaign'),
  ConversionPerformanceReport: _TL_('Conversions'),
  CustomerInvoiceReport: _TL_('Manager account invoice billing'),
  DestinationURLPerformanceReport: _TL_('Destination URL'),
  DSAAutoTargetPerformanceReport: _TL_('Dynamic search ad auto target'),
  DSACategoryPerformanceReport: _TL_('Dynamic search ad category'),
  DSASearchQueryPerformanceReport: _TL_('Dynamic search ad search term'),
  FraudChangeHistoryReport: _TL_('Fraud change history by user'),
  LabelAccountReport: _TL_('Labels - Account'),
  LabelAdReport: _TL_('Labels - Ad'),
  LabelAdGroupReport: _TL_('Labels - Ad group'),
  LabelCampaignReport: _TL_('Labels - Campaign'),
  LabelKeywordReport: _TL_('Labels - Keyword'),
  FeedItemPerformanceReport: _TL_('Feed item'),
  GeographicPerformanceReport: _TL_('Geographic'),
  GoalsAndFunnelsReport: _TL_('Goals'),
  HotelDimensionPerformanceReport: IsRenameHotelToLodgingEnabled ? _TL_('Property dimension') : _TL_('Hotel dimension'),
  HotelGroupPerformanceReport: IsRenameHotelToLodgingEnabled ? _TL_('Property group') : _TL_('Hotel group'),
  KeywordPerformanceReport: _TL_('Keyword'),
  NegativeKeywordConflictReport: _TL_('Negative keyword conflicts'),
  ProductDimensionPerformanceReport: _TL_('Product dimension'),
  ProductMatchCountReport: _TL_('Product match count'),
  ProductNegativeKeywordConflictReport: _TL_('Product negative keyword conflicts'),
  ProductPartitionPerformanceReport: _TL_('Product partition'),
  ProductPartitionUnitPerformanceReport: _TL_('Product partition unit'),
  ProductSearchQueryPerformanceReport: _TL_('Product search term'),
  ProfessionalDemographicsAudienceReport: _TL_('Professional demographics'),
  PublisherUsagePerformanceReport: _TL_('Website URL (publisher)'),
  SearchCampaignChangeHistoryReport: _TL_('Change history'),
  SearchQueryPerformanceReport: _TL_('Search term'),
  ShareOfVoiceReport: _TL_('Share of voice'),
  UserRoleChangeHistoryReport: _TL_('User role change history'),
  UserLocationPerformanceReport: _TL_('User location'),
  Other: _TL_('Other'),
};
